<template>
    <section class="section-open-positions">
        <ContainerWithOffset :offset="240">
            <div class="inner">
                <header>
                    <h2 class="heading heading--xl">Open<br/>Positions</h2>
                </header>
                <Jobs heading/>
                <div class="jobs__view-more text-center">
                    <BasicButton tag="router-link" :to="{name: POSITIONS_PAGE_NAME}" type="gradient-primary">View More
                    </BasicButton>
                </div>
            </div>
        </ContainerWithOffset>
    </section>
</template>

<script>
    import ContainerWithOffset from '../common/ContainerWithOffset'
    import Jobs from '../jobs/Jobs'
    import BasicButton from '../BasicButton'
    import {
        POSITIONS_PAGE_NAME
    } from '../../router/pageConstants'

    export default {
        name: 'open-positions',
        data() {
            return {
                POSITIONS_PAGE_NAME
            }
        },
        components: {
            ContainerWithOffset,
            Jobs,
            BasicButton
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/globals";
    @import "../../assets/scss/mixins";



    .section-open-positions {
        .inner {
            padding-top: 75px;
            padding-bottom: 125px;
        }

        .jobs__view-more {
            margin-top: 109px;
        }

        @media (max-width: $mq-md-max) {
            .inner {
                padding-bottom: 60px;
            }

            .jobs__view-more {
                margin-top: 60px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/OpenPositions.vue